import React from "react";
import {Dictionary} from "../Dictionary";

export class TableFooter extends React.Component<any, any> {
    protected dictionary: Dictionary = new Dictionary();
    render() {
        return (
            <tfoot>
            <tr style={{borderBottom: '1px solid white'}}>
                <td colSpan={this.props.colspan || 7} style={{textAlign: 'center'}}>
                    {this.dictionary.get['end']}
                </td>
            </tr>
            </tfoot>
        );
    }
}